export default __webpack_public_path__ + "media/images/facebook-0679fd6e76a6f7827361618fbf1293cd.svg";